import { posthog } from "@/lib/posthog";
import { cn } from "@/lib/utils";
import { logIkomatchClick } from "@/lib/events.functions";

export const IKOMATCH_URL = "https://link.ikomatch.com/ikomate-mehul";

export type IkomatchPlacement =
  | "results_secondary"
  | "results_lowscore"
  | "results_footer"
  | "wait_state"
  | "home_secondary"
  | "footer"
  | "free_limit"
  | "dashboard_card"
  | "upload_primary"
  | "exit_intent";

function readAnonToken(): string | undefined {
  try {
    const k = "deckscore_anon_token";
    const v = typeof localStorage !== "undefined" ? localStorage.getItem(k) : null;
    return v ?? undefined;
  } catch {
    return undefined;
  }
}

export function trackIkomatchClick(placement: IkomatchPlacement) {
  try {
    posthog.capture("ikomatch_click", { placement });
  } catch {
    /* non-fatal */
  }
  // Persist to Supabase for admin funnel attribution (fire-and-forget).
  try {
    const path = typeof window !== "undefined" ? window.location.pathname : undefined;
    void logIkomatchClick({
      data: { placement, path, anonToken: readAnonToken() },
    }).catch(() => {});
  } catch {
    /* non-fatal */
  }
}

type Props = {
  placement: IkomatchPlacement;
  children: React.ReactNode;
  className?: string;
  variant?: "link" | "button" | "unstyled";
  onClick?: () => void;
};

export function IkomatchCTA({
  placement,
  children,
  className,
  variant = "link",
  onClick,
}: Props) {
  const base =
    variant === "button"
      ? "inline-flex items-center justify-center rounded-full bg-accent px-5 py-2.5 text-[14px] font-bold text-accent-ink transition hover:bg-accent-press"
      : variant === "link"
        ? "text-accent hover:underline"
        : "";
  return (
    <a
      href={IKOMATCH_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackIkomatchClick(placement);
        onClick?.();
      }}
      className={cn(base, className)}
    >
      {children}
    </a>
  );
}
